import React from 'react';
import './RenewalOrderDetailCard.scss';

const RenewalOrderDetailCard = ({ cardText, cardImg, title = "", desc = [], className, style }) => {
    return (
        <div style={style} className={`${className} renewal-order-detail-card`}>
            {cardText ? <span className='card-header-text'>{cardText}</span> : null}
            {cardImg ? <img src={cardImg} alt={`${cardText}-card-image`} className='card-header-img'></img> : null}
            {title ? <span className='card-body-title'>{title}</span> : null}
            {desc?.length > 0 ? desc.map((line, index) => <span key={`desc${index}`} className='card-body-desc'>{line}</span>) : null}
        </div>
    )
}

export default RenewalOrderDetailCard
